import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { ExtendedRequirementDefinition } from "../../../../../query/requirementDefinitions/query/useQueryExtendedRequirementDefinition";
import { getRequirementDefinitionTemplateByParams } from "../../../../RequirementDefinitions/utils";
import { selectorPolicyTypesFromSettings } from "./selectorPolicyTypesFromSettings";

type InsuranceCoverageMonitorSettings =
  insuranceMonitorApiSpec.InsuranceCoverageMonitorSettings;

export const selectorTemplateParamsFromExtendedRequirementDefinition = (
  requirement: ExtendedRequirementDefinition
): Parameters<typeof getRequirementDefinitionTemplateByParams>[0] => {
  return {
    type: requirement.requirementType,
    contextType: requirement?.dataSource?.contextType,
    policyType: selectorPolicyTypesFromSettings(
      requirement?.dataSource as InsuranceCoverageMonitorSettings
    )
  };
};
